import * as React from 'react';
import { useTheme } from 'styled-components';
import { IRadioGroupProps, IRadioGroupOption, keyType } from './radio-group-props';
import { Title, Wrapper, RadioGroupContent } from './parts';
import { StackPanel } from '../stack-panel';

export const RadioGroup = React.memo((props: IRadioGroupProps) => {
    const { selectedKey, defaultSelectedKey = '', onValueChange,
        required = false, groupLabel = '', options, groupName, hidden,
        orientation = 'vertical', disabled, elementRef, onRenderItem, ...rest
    } = props;
    const { radioButton: { composites: { groupRadioButtonGap } } } = useTheme();
    const [activeKey, updateActiveKey] = React.useState(selectedKey || defaultSelectedKey);

    React.useEffect(() => {
        if (selectedKey !== undefined) {
            updateActiveKey(selectedKey);
        }
    }, [selectedKey]);

    const _onChange = React.useCallback((key: keyType) => {
        const selectedOption = options.find(option => option.key === key);

        if (selectedKey === undefined) {
            updateActiveKey(key);
        }

        if (onValueChange) {
            onValueChange(key, selectedOption);
        }
    }, [onValueChange, options, selectedKey]);

    const renderRadioGroupContent = React.useCallback((item: IRadioGroupOption) => {
        const { key } = item;

        return (
            <RadioGroupContent
                isSelected={activeKey === key}
                onRenderItem={onRenderItem}
                item={item}
                groupName={groupName}
                key={key}
                onChangeHandler={_onChange}
                disabled={disabled} />
        );
    }, [_onChange, activeKey, disabled, groupName, onRenderItem]);

    return hidden ? null : (
        <Wrapper ref={elementRef} {...rest}>
            <Title groupLabel={groupLabel} required={required} />
            <StackPanel className="ap-radioGroup-options-wrapper" orientation={orientation} wrap gap={String(groupRadioButtonGap)}>
                {options.map(renderRadioGroupContent)}
            </StackPanel>
        </Wrapper>
    );
});

RadioGroup.displayName = 'RadioGroup';
